<template>
  <div>
    <div class="headerStatus">
      <img
        src="@/assets/images/cloase@2x.png"
        alt=""
      />
      <h3>支用申请失败</h3>
    </div>
    <ul>
      <li
        class="infoList"
        v-for="(item, i) in list"
        :key="i"
      >
        <div class="infoListLeft">{{ item.key }}</div>
        <div class="infoListRight">{{ item.value }}</div>
      </li>
    </ul>
    <div class="btnBox">
      <div class="contractDraw">
        重新提交
      </div>
      <Button
        :text="drawHome"
        :type="danger"
        class="nextStep"
        :click="goToNextPage"
      />
    </div>
  </div>
</template>
<script>
import Button from '@/components/Button.vue';

export default {
  name: 'withdrawalFailed',
  data() {
    return {
      danger: 'danger',
      drawHome: '返回我的融资',
      list: [
        {
          key: '企业名称：',
          value: '12345678',
        },
        {
          key: '借款人：',
          value: '¥500,000.00',
        },
        {
          key: '申请产品：',
          value: '¥500,000.00',
        },
        {
          key: '评估结果：',
          value: '很遗憾，您提交的很遗憾，您提交的申请资料未通过XXX产品的初审。很遗憾，您提交的申请资料未通过XXX产品的初审。s申请资料未通过XXX产品的初审。',
        },
      ],
    };
  },
  components: {
    Button,
  },
  methods: {
    goToNextPage() {
      this.$store.dispatch('commonForms/nextJumpPage', {
        orderId: localStorage.getItem('orderId'),
      });
    },
  },
};
</script>
<style scoped>
.infoList {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  width: 90%;
  min-height: 50px;
  margin: 0 auto;
}
.infoListLeft {
  width: 100px;
  color: #7d828e;
  font-size: 14px;
  text-align: right;
}
.infoListRight {
  flex: 1;
  color: #000;
  font-size: 14px;
  text-align: left;
}
.nextStep {
  width: 150px;
  padding: 0;
  border-radius: 3px;
}
.headerStatus {
  padding-top: 35px;
}
.headerStatus img {
  width: 60px;
  height: 60px;
}
.headerStatus h3 {
  font-size: 18px;
}
.headerStatus p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.btnBox {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  margin-top: 30px;
}

.contractDraw {
  width: 150px;
  height: 40px;
  color: rgba(212, 48, 48, 1);
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  border: 1px solid rgba(212, 48, 48, 1);
  border-radius: 3px;
}
</style>
